import React from "react";
import PT from "prop-types";
import Select from "react-select";
import { usePeriodOptions } from "./hooks/usePeriodOptions";
import { useAtom } from "jotai";
import { optionPeriodAtom } from "./atoms/period";

const selectStyles = {
  control: (styles) => ({
    ...styles,
    border: "none",
    boxShadow: "0 7px 15px rgba(72,69,50,0.15)",
    borderRadius: "var(--root-br)",
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    color: isFocused || isSelected ? "white" : "black",
    background: isFocused
      ? "var(--color-cta)"
      : isSelected
      ? "var(--grad-primary-n)"
      : "transparent",
  }),
};
const PeriodSelect = (props) => {
  const options = usePeriodOptions({ priceList: props.priceList, t: props.t });
  const [period, setPeriod] = useAtom(optionPeriodAtom(options));
  return (
    <div
      css={`
        position: relative;
        z-index: 4;
      `}
    >
      <Select
        isSearchable={false}
        onChange={setPeriod}
        options={options}
        value={period}
        styles={selectStyles}
        className="subscribe-periods-select"
        components={{
          IndicatorSeparator: () => null,
        }}
      />
    </div>
  );
};
PeriodSelect.propTypes = {
  priceList: PT.object,

  t: PT.func.isRequired,
};

export default PeriodSelect;
